import React, {useEffect, useState} from "react";
import {Controller, SubmitHandler, useForm} from "react-hook-form";

import SubTitle from "../../components/SubTitle";
import {FormContents, FormSection} from "../../styledComponents/StyledCreateForm";
import MWCaption from "../../components/MWCaption";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {StyledDetailContainer, StyledDetailTable} from "../../styledComponents/StyledDetail";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import * as dangerEvaluationApi from "../../api/permissionApi/dangerEvaluationApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import {useCreateMutation, useGetItemQuery} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {
  WPDangerEvaluation,
  initializeDangerEvaluation,
} from "../../models/serverModels/permission/WPDangerEvaluation";
import {useNavigate, useParams} from "react-router-dom";
import {useQueryClient} from "react-query";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import MWProgress from "../../components/MWProgress";
import {createBrowserHistory} from "history";

const StyleCheckBox = styled(FormControlLabel)(({theme}) => ({
  display: "block",
  "& span": {fontSize: "14px"},
  "& .MuiSvgIcon-root": {fontSize: 16},
}));

const DangerEvaluationCheckPermission = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);
  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const history = createBrowserHistory();

  const {data: checkItems, isLoading: isGetLoading} = useGetItemQuery<
    ResponseItem<WPDangerEvaluation>
  >({
    key: ["dangerEvaluationForCheck", id],
    api: () => dangerEvaluationApi.getCheck({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: createMutate, isLoading: isCreateLoading} = useCreateMutation<
    ResponseItem<WPDangerEvaluation>,
    Params.Create<WPDangerEvaluation>
  >({
    api: dangerEvaluationApi.createCheck,
    options: {
      onSuccess: async () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Permission/List`);
        queryClient.invalidateQueries({queryKey: ["DangerEvaluationList"]});
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const {control, reset, handleSubmit, setValue, getValues, watch} = useForm<WPDangerEvaluation>({
    defaultValues: checkItems?.item || initializeDangerEvaluation(),
  });

  console.log(getValues("generalCheckItems"));
  const onSubmit: SubmitHandler<WPDangerEvaluation> = (data) => {
    createMutate({
      token: tokenState,
      item: {
        ...checkItems?.item,
        ...data,
      },
    });
  };

  useEffect(() => {
    reset(checkItems?.item);
  }, [checkItems?.item, reset]);

  useEffect(() => {
    const listenBackEvent = () => {
      navigate(`/Permission/Edit/${id}`);
    };
    const unListenHistoryEvent = history.listen(({action}) => {
      if (action === "POP") {
        listenBackEvent();
      }
    });

    return () => {
      history.listen(unListenHistoryEvent);
    };
  }, []);

  return (
    <React.Fragment>
      <SubTitle subTitle="작업위험성평가 세부항목" />
      {isCreateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormSection>
            <StyledDetailContainer>
              <MWCaption title="안전조치 요구사항 3" color="#01579B" icon={<SpellcheckIcon />} />
              <FormContents container rowSpacing={4}>
                <StyledDetailTable>
                  <Table>
                    <TableBody>
                      {checkItems?.item?.generalCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.generalCheckItems
                                        ? checkItems?.item?.generalCheckItems.every((item, index) =>
                                            watch(`generalCheckItems.${index}.itemValue.isChecked`)
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.generalCheckItems.map((item, index) =>
                                            setValue(
                                              `generalCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.generalCheckItems.map((item, index) =>
                                            setValue(
                                              `generalCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">일반작업</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.generalCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`generalCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}

                      {checkItems?.item?.fireCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell component="td" align="center">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.fireCheckItems
                                        ? checkItems?.item?.fireCheckItems.every((item, index) =>
                                            watch(`fireCheckItems.${index}.itemValue.isChecked`)
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.fireCheckItems.map((item, index) =>
                                            setValue(
                                              `fireCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.fireCheckItems.map((item, index) =>
                                            setValue(
                                              `fireCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">화기작업</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.fireCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`fireCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.closedCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.closedCheckItems
                                        ? checkItems?.item?.closedCheckItems.every((item, index) =>
                                            watch(`closedCheckItems.${index}.itemValue.isChecked`)
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.closedCheckItems.map((item, index) =>
                                            setValue(
                                              `closedCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.closedCheckItems.map((item, index) =>
                                            setValue(
                                              `closedCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">밀폐작업</TableCell>
                            <TableCell component="td">
                              {checkItems?.item?.closedCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`closedCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.excavationCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.excavationCheckItems
                                        ? checkItems?.item?.excavationCheckItems.every(
                                            (item, index) =>
                                              watch(
                                                `excavationCheckItems.${index}.itemValue.isChecked`
                                              )
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.excavationCheckItems.map(
                                            (item, index) =>
                                              setValue(
                                                `excavationCheckItems.${index}.itemValue.isChecked`,
                                                true
                                              )
                                          )
                                        : checkItems?.item?.excavationCheckItems.map(
                                            (item, index) =>
                                              setValue(
                                                `excavationCheckItems.${index}.itemValue.isChecked`,
                                                false
                                              )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">굴착작업허가</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.excavationCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`excavationCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.heavyCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.heavyCheckItems
                                        ? checkItems?.item?.heavyCheckItems.every((item, index) =>
                                            watch(`heavyCheckItems.${index}.itemValue.isChecked`)
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.heavyCheckItems.map((item, index) =>
                                            setValue(
                                              `heavyCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.heavyCheckItems.map((item, index) =>
                                            setValue(
                                              `heavyCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">중장비작업허가</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.heavyCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`heavyCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.heightCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.heightCheckItems
                                        ? checkItems?.item?.heightCheckItems.every((item, index) =>
                                            watch(`heightCheckItems.${index}.itemValue.isChecked`)
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.heightCheckItems.map((item, index) =>
                                            setValue(
                                              `heightCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.heightCheckItems.map((item, index) =>
                                            setValue(
                                              `heightCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">고소작업허가</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.heightCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`heightCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.radiationCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.radiationCheckItems
                                        ? checkItems?.item?.radiationCheckItems.every(
                                            (item, index) =>
                                              watch(
                                                `radiationCheckItems.${index}.itemValue.isChecked`
                                              )
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.radiationCheckItems.map((item, index) =>
                                            setValue(
                                              `radiationCheckItems.${index}.itemValue.isChecked`,
                                              true
                                            )
                                          )
                                        : checkItems?.item?.radiationCheckItems.map((item, index) =>
                                            setValue(
                                              `radiationCheckItems.${index}.itemValue.isChecked`,
                                              false
                                            )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">방사선작업허가</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.radiationCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`radiationCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      {checkItems?.item?.stopElectricityCheckItems && (
                        <>
                          <TableRow style={{backgroundColor: "#f0fafa"}}>
                            <TableCell align="center" width="20%">
                              구분
                            </TableCell>
                            <TableCell align="center" sx={{position: "relative"}}>
                              <FormControlLabel
                                sx={{
                                  position: "absolute",
                                  left: "16px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  ".MuiFormControlLabel-label": {fontSize: 14},
                                }}
                                control={
                                  <Checkbox
                                    checked={
                                      checkItems?.item?.stopElectricityCheckItems
                                        ? checkItems?.item?.stopElectricityCheckItems.every(
                                            (item, index) =>
                                              watch(
                                                `stopElectricityCheckItems.${index}.itemValue.isChecked`
                                              )
                                          )
                                        : false
                                    }
                                    onChange={(event) => {
                                      event.target.checked
                                        ? checkItems?.item?.stopElectricityCheckItems.map(
                                            (item, index) =>
                                              setValue(
                                                `stopElectricityCheckItems.${index}.itemValue.isChecked`,
                                                true
                                              )
                                          )
                                        : checkItems?.item?.stopElectricityCheckItems.map(
                                            (item, index) =>
                                              setValue(
                                                `stopElectricityCheckItems.${index}.itemValue.isChecked`,
                                                false
                                              )
                                          );
                                    }}
                                  />
                                }
                                label="전체선택"
                              />
                              세부항목(해당하는 부분에 모두 체크하세요)
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="td">정전작업허가</TableCell>

                            <TableCell component="td">
                              {checkItems?.item?.stopElectricityCheckItems.map((item, index) => (
                                <Controller
                                  key={item.uid}
                                  name={`stopElectricityCheckItems.${index}.itemValue.isChecked`}
                                  control={control}
                                  defaultValue={false}
                                  render={({field}) => (
                                    <StyleCheckBox
                                      control={
                                        <Checkbox onChange={field.onChange} checked={field.value} />
                                      }
                                      label={item.itemValue.name}
                                    />
                                  )}
                                />
                              ))}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </StyledDetailTable>
              </FormContents>
            </StyledDetailContainer>
          </FormSection>
          <ConfirmButtonGroup
            link={`/Permission/Edit/${id}`}
            cancelText="취소"
            confirmText="저장"
          />
        </form>
      )}
    </React.Fragment>
  );
};

export default DangerEvaluationCheckPermission;
